import type { CreateRouterRequest, RouterEntity } from "../../../domain/types/router";
import { RouterEntitySchema } from "../../../domain/types/router";
import type { AdminRouterRepository } from "../../../domain/repositories/admin/admin-router-repository";
import { adminRouterService } from "../../api/admin/admin-router-service";

export class AdminRouterRepositoryImpl implements AdminRouterRepository {
  async createRouter(companyId: number, request: CreateRouterRequest): Promise<void> {
    await adminRouterService.createRouter(companyId, request);
  }

  async getRouters(companyId: number): Promise<RouterEntity[]> {
    const response = await adminRouterService.getRouters(companyId);

    if (response.data) {
      return response.data.map(router => RouterEntitySchema.parse(router));
    }

    throw new Error(response.errorMsg || "라우터 가져오기 실패.");
  }
}